import React from "react";
import { Table } from "antd";
import "./default-table.css";

const DefaultTable = (props: any) => {
  return (
    <>
      <div className="table-override">
        <Table
          {...props}
          rowClassName={(record, rowIndex) => {
            return rowIndex % 2 === 0 ? "even-row" : "odd-row";
          }}
        />
      </div>
      <style>{`
        .table-override :global(.ant-table-thead > tr > th) {
          background-color: #DEE1E3;
        }
        .even-row {
          cursor: pointer;
          background-color: white;
        }
        .odd-row {
          cursor: pointer;
          background-color: white;
        }
      `}</style>
    </>
  );
};

export default DefaultTable;
